import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';

import { CustomDropdown } from "../../../../../../common/custom-form/custom-dropdown.component";
import AddressDetails from "../../../../../inventory/DetailsView/add-address.component";
import { TRANSLATIONS as translation } from "../../../../../../../utils/constant.utils";
import translationComponent from "../../../../../../common/translation/translation.component";
import { Selected_Index } from "../../../../../../../constants/external-constants";

class BillingLocationDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeDropdown: 0
        }
    }
    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    onChangeAddress = () => {
        const { billingAddress, remitAddress } = this.props.billingAccountForm;

        if (billingAddress.locationID === "") {
            this.props.selectLocation('.billingAddress.locationID', -1)
        }
        if (remitAddress.locationID === "") {
            this.props.selectLocation('.remitAddress.locationID', -1)
        }
    }



    render() {

        const { billingAccountForm, allAddressLocation1, allAddressLocation2, selectLocation, hasMoreLocation1, hasMoreLocation2, isLocationLoading, loadMoreLocation1, loadMoreLocation2, handleLocationSearch1, handleLocationSearch2 } = this.props
        const { billingAddress, remitAddress } = billingAccountForm

        this.onChangeAddress();

        return (
            <>
                <div className="horizontal-separator"></div>
                <CustomDropdown label={`${this.toLocaleLanguage('location_billing_address')}`} isActive={this.state.activeDropdown === Selected_Index.i_Zero} onToggle={() => this.handelToggleDropdown(Selected_Index.i_Zero)}>
                    <div className="add-sim-container">
                        <AddressDetails
                            locationDetails={billingAddress}
                            translator={(x) => this.toLocaleLanguage(x)}
                            inventoryAllLocations={allAddressLocation1}
                            circuitKey=""
                            fieldProp="billingAccountForm.billingAddress"
                            formName="billingAccountForm"
                            onChangeAction={selectLocation}
                            loadMoreLocation={loadMoreLocation1}
                            handleLocationSearch={handleLocationSearch1}
                            hasMoreLocation={hasMoreLocation1}
                            isLocationLoading={isLocationLoading}
                        />
                    </div>
                </CustomDropdown>
                <CustomDropdown label={`${this.toLocaleLanguage('location_remit_address')}`} isActive={this.state.activeDropdown === Selected_Index.i_Zero} onToggle={() => this.handelToggleDropdown(Selected_Index.i_Zero)}>
                    <div className="add-sim-container">
                        <AddressDetails
                            locationDetails={remitAddress}
                            translator={(x) => this.toLocaleLanguage(x)}
                            inventoryAllLocations={allAddressLocation2}
                            circuitKey=""
                            fieldProp="billingAccountForm.remitAddress"
                            formName="billingAccountForm"
                            onChangeAction={selectLocation}
                            loadMoreLocation={loadMoreLocation2}
                            handleLocationSearch={handleLocationSearch2}
                            hasMoreLocation={hasMoreLocation2}
                            isLocationLoading={isLocationLoading}
                        />
                    </div>
                </CustomDropdown>
            </>
        )
    }
}

export default withRouter(
    connect(
        state => {
            const { translation } = state;
            const { billingAccountForm, accountLocationForm, forms: { billingAccountForm: { $form } } } = state.form

            return {
                ...translation
                , billingAccountForm
                , accountLocationForm
                , $form

            };
        },
        dispatch => ({
            ...bindActionCreators(
                Object.assign({}), dispatch
            ),
            FormLoad: (model, data) => {
                dispatch(actions.load(model, data));
            }
        })
    )(BillingLocationDetails)
);